<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
      <div class="pull-right">
        <b-button v-if="section === ''" @click="section = 'edit'" variant="outline-primary"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"          :active="section === ''"         >Preview</b-nav-item>
        <b-nav-item @click="section = 'locations'" :active="section === 'locations'">Locations</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
export default {
  name: 'customer_detail',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    const { companyId } = this.$route.params;
    this.$store.commit('customers/SET_DETAIL_ID', companyId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'customers', name: 'Customers' },
      { to: companyId, name: 'Detail' },
    ]);
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
    detailedInfo() {
      return this.$store.getters['customers/get_detail_data'];
    },
    displayName() {
      const { name } = this.detailedInfo;
      return name;
    },
  },
  watch: {
    section(newSection) {
      this.$router.push(`/shipment_md/customers/${this.companyId}/${newSection}`);
    },
    companyId(newCompanyId) {
      this.$store.commit('customers/SET_DETAIL_ID', newCompanyId);
      this.$store.dispatch('customers/LOAD_DETAIL_DATA');
      this.section = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/customers/Detail.vue